import { FC, useMemo } from "react";
import { DropdownListItemTeamEdit, SettingsDotsWrapper } from "../styles";
import { useTheme } from "styled-components";
import { Dropdown } from "@brg/ui";
import { SettingsDotsIcon } from "shared/icons/SettingsDotsIcon";
import { useTranslation } from "react-i18next";
import { useRouteMatch } from "react-router-dom";
import { useTeamContext } from "../provider/TeamContext";
import { useTeamActionsMenu } from "shared/pages/teams/hooks/useTeamActionsMenu";

export const TeamEditTooltip: FC<{ teamId: string; position: "absolute" | "static" }> = ({
    position,
}) => {
    const theme = useTheme();
    const { t } = useTranslation();
    const { team } = useTeamContext();
    const isTeams = !!useRouteMatch(["/teams/:teamName", "/teams/:teamName/brnd"]);
    const {
        isVisible,
        canEdit,
        canShare,
        canJoin,
        canReport,
        isChannel,
        handleEdit,
        handleShare,
        handleJoin,
        handleReport,
    } = useTeamActionsMenu(team);

    const tooltipPos = useMemo(() => {
        if (isChannel) {
            return {
                desktop: {
                    x: 16,
                    y: 16,
                },
                mobile: {
                    x: 16,
                    y: 16,
                },
            };
        }
        return {
            desktop: {
                x: 16,
                y: 16,
            },
            mobile: {
                x: 8,
                y: 24,
            },
        };
    }, [isChannel]);

    if (!isTeams || !isVisible) {
        return null;
    }

    return (
        <SettingsDotsWrapper
            className="team-actions-dots"
            tooltipPos={tooltipPos}
            position={position}
            shouldDisplayEmblem={true}
        >
            <Dropdown
                offsetY={8}
                offsetX={0}
                hideArrow
                orientation="right"
                target={<SettingsDotsIcon />}
            >
                {canEdit && (
                    <DropdownListItemTeamEdit theming={theme.navigationBar.login} onClick={handleEdit}>
                        {t(`edit-${isChannel ? "channel" : "organization"}`)}
                    </DropdownListItemTeamEdit>
                )}
                {canShare && (
                    <DropdownListItemTeamEdit theming={theme.navigationBar.login} onClick={handleShare}>
                        {t("sharing.title").toLowerCase()}
                    </DropdownListItemTeamEdit>
                )}
                {canJoin && (
                    <DropdownListItemTeamEdit theming={theme.navigationBar.login} onClick={handleJoin}>
                        {t("teams.buttons.become_a_member").toLowerCase()}
                    </DropdownListItemTeamEdit>
                )}
                {canReport && (
                    <DropdownListItemTeamEdit theming={theme.navigationBar.login} onClick={handleReport}>
                        {t("send_report").toLowerCase()}
                    </DropdownListItemTeamEdit>
                )}
            </Dropdown>
        </SettingsDotsWrapper>
    );
};
import { FC, useMemo } from "react";
import { DropdownListItemTeamEdit, SettingsDotsWrapper } from "../styles";
import { useTheme } from "styled-components";
import { Dropdown } from "@brg/ui";
import { SettingsDotsIcon } from "shared/icons/SettingsDotsIcon";
import { useTranslation } from "react-i18next";
import { useRouteMatch } from "react-router-dom";
import { useTeamContext } from "../provider/TeamContext";
import { useTeamActionsMenu } from "shared/pages/teams/hooks/useTeamActionsMenu";

export const TeamEditTooltip: FC<{ teamId: string; position: "absolute" | "static" }> = ({
    position,
}) => {
    const theme = useTheme();
    const { t } = useTranslation();
    const { team } = useTeamContext();
    const isTeams = !!useRouteMatch(["/teams/:teamName", "/teams/:teamName/brnd"]);
    const {
        isVisible,
        canEdit,
        canShare,
        canJoin,
        canReport,
        isChannel,
        handleEdit,
        handleShare,
        handleJoin,
        handleReport,
    } = useTeamActionsMenu(team);

    const tooltipPos = useMemo(() => {
        if (isChannel) {
            return {
                desktop: {
                    x: 16,
                    y: 16,
                },
                mobile: {
                    x: 16,
                    y: 16,
                },
            };
        }
        return {
            desktop: {
                x: 16,
                y: 16,
            },
            mobile: {
                x: 8,
                y: 24,
            },
        };
    }, [isChannel]);

    if (!isTeams || !isVisible) {
        return null;
    }

    return (
        <SettingsDotsWrapper
            className="team-actions-dots"
            tooltipPos={tooltipPos}
            position={position}
            shouldDisplayEmblem={true}
        >
            <Dropdown
                offsetY={8}
                offsetX={0}
                hideArrow
                orientation="right"
                target={<SettingsDotsIcon />}
            >
                {canEdit && (
                    <DropdownListItemTeamEdit theming={theme.navigationBar.login} onClick={handleEdit}>
                        {t(`edit-${isChannel ? "channel" : "organization"}`)}
                    </DropdownListItemTeamEdit>
                )}
                {canShare && (
                    <DropdownListItemTeamEdit theming={theme.navigationBar.login} onClick={handleShare}>
                        {t("sharing.title").toLowerCase()}
                    </DropdownListItemTeamEdit>
                )}
                {canJoin && (
                    <DropdownListItemTeamEdit theming={theme.navigationBar.login} onClick={handleJoin}>
                        {t("teams.buttons.become_a_member").toLowerCase()}
                    </DropdownListItemTeamEdit>
                )}
                {canReport && (
                    <DropdownListItemTeamEdit theming={theme.navigationBar.login} onClick={handleReport}>
                        {t("send_report").toLowerCase()}
                    </DropdownListItemTeamEdit>
                )}
            </Dropdown>
        </SettingsDotsWrapper>
    );
};
